import { render, staticRenderFns } from "./main-button.vue?vue&type=template&id=229c1fa1&scoped=true"
import script from "./main-button.vue?vue&type=script&lang=js"
export * from "./main-button.vue?vue&type=script&lang=js"
import style0 from "./main-button.vue?vue&type=style&index=0&id=229c1fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c1fa1",
  null
  
)

export default component.exports